var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoller(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66667 21.6875V4.121C2.66667 3.53738 2.87778 3.03819 3.30001 2.62344C3.72223 2.20869 4.22889 2.00087 4.82001 2H19.18C19.772 2 20.2787 2.20781 20.7 2.62344C21.1213 3.03906 21.3324 3.53781 21.3333 4.11969V21.6875H23.3333C23.5227 21.6875 23.6809 21.7505 23.808 21.8765C23.9351 22.0025 23.9991 22.1587 24 22.3451C24.0009 22.5314 23.9369 22.6872 23.808 22.8123C23.6791 22.9374 23.5209 23 23.3333 23H0.666675C0.477342 23 0.31912 22.937 0.192009 22.811C0.0648981 22.685 0.000898021 22.5288 9.1324e-06 22.3424C-0.000879756 22.1561 0.0631203 22.0003 0.192009 21.8752C0.320898 21.7501 0.47912 21.6875 0.666675 21.6875H2.66667ZM4.00001 11.9697H20V4.121C20 3.88475 19.9231 3.69094 19.7693 3.53956C19.6155 3.38819 19.4191 3.3125 19.18 3.3125H4.82001C4.58089 3.3125 4.38445 3.38819 4.23067 3.53956C4.07689 3.69094 4.00001 3.88475 4.00001 4.121V11.9697ZM4.00001 21.6875H20V13.2822H12.6667V16.7551C12.9262 16.8899 13.1324 17.071 13.2853 17.2985C13.4364 17.526 13.512 17.7859 13.512 18.0781C13.512 18.4894 13.364 18.8403 13.068 19.1308C12.772 19.4212 12.4142 19.5669 11.9947 19.5678C11.5751 19.5687 11.2196 19.423 10.928 19.1308C10.6364 18.8385 10.4898 18.4876 10.488 18.0781C10.488 17.7859 10.5636 17.5273 10.7147 17.3024C10.8676 17.0776 11.0738 16.8977 11.3333 16.763V13.2822H4.00001V21.6875Z",
    fill: "url(#paint0_linear_1042_394)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1042_394",
    x1: 0,
    y1: 12.5,
    x2: 24,
    y2: 12.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#0B3568"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#107650"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoller);
export default __webpack_public_path__ + "static/media/roller.6ed59598a71290f0710e77e09507e4ba.svg";
export { ForwardRef as ReactComponent };